import { render, staticRenderFns } from "./AiChatModule.vue?vue&type=template&id=50010a3b&scoped=true&"
import script from "./AiChatModule.vue?vue&type=script&lang=ts&"
export * from "./AiChatModule.vue?vue&type=script&lang=ts&"
import style0 from "./AiChatModule.vue?vue&type=style&index=0&id=50010a3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50010a3b",
  null
  
)

export default component.exports